const tempTitle = '使用文章标题#'
const tempContent = '使用文章内容'
const personalName = '登录用户或文章作者昵称#'
const welcomeTo = '欢迎来到'

// 生产服务器
const beianId = '粤ICP备2023104090号'
const homeUrl = 'https://1688.lefonshop.cn'

// logo
const logoGrey = '/public/images/default/logo-lefonshop-bg-grey.png'
const logoBg = '/public/images/default/logo-lefonshop-bg.png'

/* 以上常量不可修改 */
/* 请在src/assets/images文件夹中替换logo.png*/
/* 请在public文件夹中favicon.ico*/
/* 新注册用户默认关注uid为33的官方账号 */

exports.config = {
    appName: '绿锋1688',
    appId: 'lefonshop',
    mode: 'shop', // shop-电商平台
    shopId: 'lefonshop', // 电商模式必填
    homeUrl: homeUrl,
    beianId: beianId, // 备案号
    shopName: '日锋广州运营中心',
    requireInvitationCode: true, // 是否启动内测邀请码
    servicePhone: '13600043886', // 13435631044阿迪电话
    port:'1688',
    version: '1.3.0',
    showBeian: true, // 是否展示备案号
    showCopyRight: false, // 是否展示版权证书
    firstFooterName: '绿锋', // 自定义FooterName, 不填默认显示首页
    seoPage:{
        // 默认
        default:{
            title: '欢迎您来',
            keywords: '衣柜灯测评,酒柜灯测评,橱柜灯测评,灯具测评,无主灯测评,小夜灯测评,壁灯测评,应景照明,应景小灯,绿锋1688,筒灯测评,集电集控,消防应急,感应灯测评',
            description: '精选全网家具照明领域测评文章,为准备入住新家的你,提供应景实用的灯具装修建议,包括但不限于衣柜灯测评,筒灯测评,小夜灯测评,无主灯测评,感应灯测评,雷达感应测评,人体感应测评,声光控测评。'
        },
        // 首页
        homePage:{
            title: '欢迎您来',
            keywords: '衣柜灯测评,酒柜灯测评,橱柜灯测评,灯具测评,无主灯测评,小夜灯测评,壁灯测评,应景照明,应景小灯,绿锋1688,筒灯测评,集电集控,消防应急,感应灯测评',
            description: '精选全网家具照明领域测评文章,为准备入住新家的你,提供应景实用的灯具装修建议,包括但不限于衣柜灯测评,筒灯测评,小夜灯测评,无主灯测评,感应灯测评,雷达感应测评,人体感应测评,声光控测评。'
        },
        // 聊个小天AI
        chatPage:{
            title: '聊个小天',
            keywords: '职场经验,职场技巧,职场哲学,职场面试,职场实战经验,职场成长,职场案例,职场心得,职场认知体会,职场陷阱,职场生存,职场pua,职场黑化,职场攻略,职场礼仪',
            description: '精选全网职场成长经验,为初入职场的你,提供职场经验加成,为等待晋升的你,助上一把力,包括但不限于职场经验,职场技巧,职场哲学,职场面试,职场实战经验,职场成长,职场案例,职场心得,职场认知体会,职场陷阱,职场生存,职场pua,职场黑化,职场攻略,职场礼仪。'
        },
        // 商城主页
        shopPage:{
            title: '欢迎您来',
            keywords: '衣柜灯,衣柜灯测评,酒柜灯,酒柜灯测评,灯具,灯具测评,无主灯,无主灯测评,小夜灯,小夜灯测评,应景照明,应景小灯,绿锋1688,筒灯,筒灯测评,集电集控,消防应急,感应灯',
            description: '在这里选购全网最精致,最实用的灯具产品,入住新家不能没有他,包括但不限于衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
        },
        // 产品分类页
        categoryPage:{
            title: '产品分类',
            keywords: '衣柜灯,衣柜灯测评,酒柜灯,酒柜灯测评,灯具,灯具测评,无主灯,无主灯测评,小夜灯,小夜灯测评,应景照明,应景小灯,绿锋1688,筒灯,筒灯测评,集电集控,消防应急,感应灯',
            description: '在这里选购全网最精致,最实用的灯具产品,入住新家不能没有他,包括但不限于衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
        },
        // 采购车页
        cartPage:{
            title: '采购车',
            keywords: '衣柜灯,衣柜灯测评,酒柜灯,酒柜灯测评,灯具,灯具测评,无主灯,无主灯测评,小夜灯,小夜灯测评,应景照明,应景小灯,绿锋1688,筒灯,筒灯测评,集电集控,消防应急,感应灯',
            description: '在这里选购全网最精致,最实用的灯具产品,入住新家不能没有他,包括但不限于衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
        },
        // 文章详情页
        articlePage:{
            title: tempTitle +'绿锋1688',
            keywords: '衣柜灯测评,酒柜灯测评,橱柜灯测评,灯具测评,无主灯测评,小夜灯测评,壁灯测评,感应灯测评,射灯测评,集电集控',
            description: tempContent
        },
        // 个人主页、作者主页
        personalPage:{
            title: personalName + '的个人主页-绿锋1688',
            keywords: '衣柜灯测评,酒柜灯测评,橱柜灯测评,灯具测评,无主灯测评,小夜灯测评,壁灯测评,感应灯测评,射灯测评,集电集控',
            description: welcomeTo + personalName + '的个人主页,快来和我一起参与绿锋1688社区吧~'
        },
        // 商品详情主页
        shopDescPage:{
            title: '发现优质灯具产品',
            keywords: '衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯',
            description: '在这里选购全网最精致,最实用的灯具产品,入住新家不能没有他,包括但不限于衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
        },
        aboutPage:{
            title: '关于绿锋1688',
            keywords: '衣柜灯,衣柜灯测评,酒柜灯,酒柜灯测评,灯具,灯具测评,无主灯,无主灯测评,小夜灯,小夜灯测评,应景照明,应景小灯,绿锋1688,筒灯,筒灯测评,集电集控,消防应急,感应灯',
            description: '集中衣柜灯测评,筒灯测评,小夜灯测评,无主灯测评,感应灯测评,雷达感应测评,人体感应测评,声光控测评等相关资源。参与消防资讯领域，参与氛围灯测评领域，成为有价值社区。全网精准用户流量起爆，赋能小白从零到一做软件开发项目。'
        }
    },
    aboutUs: [{
        question:'绿锋1688有何价值？',
        answer:'采购商、顾客通过助手能够浏览产品，浏览产品分类，按型号、名称搜索产品，浏览产品详情页查看同一个产品的不同款式以及其他详情图片'
    },{
        question:'愿景与目标',
        answer:'愿景：实现档口数字化转型。目标：档口、仓储式老板、中小企业数字化进程中不落后'
    },{
        question:'绿锋1688有何特点？',
        answer:'我们致力于打造界面简洁、良好用户体验的选品平台。欢迎销售工程师、五金建材领域意见领袖、消防领域大中小V、灯具经销商合作交流。'
    },{
        question:'怎样让用户有获得感？',
        answer:'用户使用绿锋1688找到需要的产品详情；包括详情图片以及规格；用户在此过程中得到比较良好的选品体验'
    }],
    commonQA: [{
        question:'绿锋目前是在做电商吗？',
        answer:'绿锋1688和电商有明显区别的，绿锋1688更倾向于帮助客户更好的做电商，客户在绿锋1688以一手价格进货，在其他渠道售卖，正常情况下不产生利益冲突~'
    },{
        question:'为什么首次要邀请码才能进入平台？',
        answer:'绿锋1688采用邀请制，每位用户都是独家邀请的尊贵客户，客户可以在平台内得到很好的选品服务，一般都能拿到令人中意的价格~'
    }],
    logo: homeUrl + logoBg,
    poster:[{
        url: homeUrl + '/public/images/default/poster618.png'
    },{
        url: homeUrl + '/public/images/default/poster622.png'
    }],
    wxConfig:{
        appId:'wxa0196ed6c7eea972',
        // 首页微信分享
        homePage:{
            title: '绿锋社区',
            desc: '',
            link: homeUrl,
            imgUrl: homeUrl + logoGrey
        },
        // 文章详情页微信分享
        articlePage:{
            title: '绿锋社区',
            desc: '',
            link: homeUrl,
            imgUrl: homeUrl + logoGrey
        },
        // 商城首页微信分享
        shopPage:{
            title: '绿锋1688',
            desc: '快来和我一起探索绿锋1688吧~',
            link: homeUrl,
            imgUrl: homeUrl + logoGrey
        },
        // 商城分类微信分享
        categoryPage:{
            title: '产品分类',
            desc: '随时和我一起探索绿锋1688的产品吧~',
            link: homeUrl,
            imgUrl: homeUrl + logoGrey
        },
        // 商品详情分享
        goodsPage:{
            title: '',
            desc: '这个产品还不错,快查看产品详情吧~',
            link: homeUrl,
            imgUrl: homeUrl + logoGrey
        },
        // 个人主页、作者主页微信分享
        personalPage:{
            title: personalName +'的个人主页-绿锋运营中心',
            desc: '',
            link: homeUrl,
            imgUrl: 'https://yingjing.emer-nav.cn/public/images/default/avatar.png'
        }
    },
    // 搜索发现
    searchLists:[
    //     {
    //     id:'booking',
    //     text: '预购'
    // },
    // {
    //     id:'createArticle',
    //     text: '创建文章'
    // },{
    //     id:'draftBox',
    //     text: '草稿箱'
    // },
    // {
    //     id: 'download',
    //     text: '下载Apk'
    // },
    {
        id:'category',
        text:'产品分类',
    },
    {
        id:'serviceWX',
        text:'客服微信',
    },
    // {
    //     id:'service',
    //     text:'客服热线',
    // },
    {
        id:'personal',
        text:'我的主页',
    },
    {
        id:'vision',
        text:'关于我们',
    },

    {
        id:'logout',
        text:'退出登录',
    }
    ],
}